<template>
  <section class="contact-wrapper">
    <div class="contact-container">

      <div class="form-card">
        <h2 class="card-title">Send us a message</h2>
        <p class="description">
          Report your scam case here — our <span class="green-text">cryptocurrency recovery specialists</span> will
          review your loss and help you reclaim your digital assets quickly and securely. Fill out the form below to get
          professional support from a trusted recovery expert.
        </p>

        <form @submit.prevent>
          <div class="form-grid">
            <div class="form-group">
              <label class="green-label">Name *</label>
              <input type="text" v-model="form.name" placeholder="Name" />
            </div>
            <div class="form-group">
              <label class="green-label">Email *</label>
              <input type="email" v-model="form.email" placeholder="Email" />
            </div>

            <div class="form-group">
              <label class="green-label">Phone Number</label>
              <input type="tel" v-model="form.phone" placeholder="Phone Number" />
            </div>
            <div class="form-group">
              <label class="green-label">Country</label>
              <input type="text" v-model="form.country" placeholder="Country" />
            </div>

            <div class="form-group full-width">
              <label class="green-label">Your inquiry about</label>
              <input type="text" v-model="form.inquiry" placeholder="Your inquiry about" />
            </div>

            <div class="form-group full-width">
              <label class="green-label">Message</label>
              <textarea v-model="form.message" placeholder="Message..."></textarea>
            </div>
          </div>

          <div class="terms-box">
            <input type="checkbox" id="terms" v-model="form.terms" />
            <label for="terms">I accept the Terms & Conditions</label>
          </div>

          <button @click="sendMessage" type="submit" class="send-btn">SEND MESSAGE ➤</button>
        </form>
      </div>

      <!-- <div class="info-card">
        <div class="contact-item">
          <span class="icon purple">☎</span>
          <span class="value bold">+1 (934) 201-3499</span>
        </div>
        <div class="contact-item">
          <span class="icon purple">✉</span>
          <span class="value bold">Admin@fraudcounsel.net</span>
        </div>

        <div class="social-icons">
          <span class="social-btn">▶</span>
          <span class="social-btn">𝕏</span>
          <span class="social-btn">in</span>
          <span class="social-btn">f</span>
        </div>

        <div class="divider"></div>

        <h3 class="info-title">United States Headquarters</h3>
        <p class="info-text">250 International Pkwy, Lake Mary, FL 32746</p>

        <div class="divider"></div>

        <h3 class="info-title">Working Hours</h3>
        <p class="info-text">Monday – Saturday Open 24 Hours<br>
          Sunday 12:00 AM – 4:00 PM (EST)<br>
          Priority support available during Sunday hours.</p>
      </div> -->

    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        country: '',
        inquiry: '',
        message: '',
        terms: false
      }
    };
  },
  methods: {
    sendMessage() {
      this.form = {
        name: '',
        email: '',
        phone: '',
        country: '',
        inquiry: '',
        message: '',
        terms: false
      }
    }
  }
}
</script>

<style scoped>
.contact-wrapper {
  padding: 60px 5%;
  display: flex;
  justify-content: center;
  color: #CCCEEF;
}

.contact-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  max-width: 1200px;
  width: 100%;
}

.form-card,
.info-card {
  background: #12151d;
  border-radius: 16px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.card-title {
  font-size: 2.2rem;
  margin: 0 0 20px;
}

.description {
  color: #aaa;
  line-height: 1.6;
  margin-bottom: 40px;
}

.green-text {
  color: #00d68f;
  font-weight: bold;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.full-width {
  grid-column: span 2;
}

.green-label {
  color: #00d68f;
  text-transform: uppercase;
  font-size: 0.85rem;
  margin-bottom: 10px;
  letter-spacing: 1px;
}

input,
select,
textarea {
  background: #0b0e14;
  border: 1px solid #2a303c;
  border-radius: 6px;
  padding: 15px;
  color: #fff;
  font-size: 1rem;
  outline: none;
}

textarea {
  height: 120px;
  resize: none;
}

.terms-box {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 30px 0;
  color: #ddd;
}

.send-btn {
  width: 100%;
  padding: 18px;
  background: linear-gradient(90deg, #86e59e, #00d68f);
  border: none;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: bold;
  color: #000;
  cursor: pointer;
  transition: all 0.3s ease;
}

.send-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 214, 143, 0.3);
}

/* 右侧信息样式 */
.contact-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.icon {
  width: 24px;
  text-align: center;
}

.icon.purple {
  color: #c77dff;
  font-size: 1.5rem;
}

.value {
  font-size: 1.4rem;
}

.bold {
  font-weight: bold;
}

.social-icons {
  display: flex;
  gap: 15px;
  margin-top: 30px;
}

.social-btn {
  width: 45px;
  height: 45px;
  background: #1b202a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  transition: 0.3s;
}

.social-btn:hover {
  background: #00d68f;
  color: #000;
}

.divider {
  height: 1px;
  background: #2a303c;
  margin: 40px 0;
}

.info-title {
  font-size: 1.4rem;
  margin: 0 0 20px;
  font-weight: 600;
}

.info-text {
  color: #aaa;
  line-height: 1.8;
  font-size: 1.1rem;
  margin: 0;
}

@media (max-width: 768px) {

  .contact-wrapper {
    padding: 40px 20px;
  }

  .contact-container {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .full-width {
    grid-column: span 1;
  }

  .form-card,
  .info-card {
    padding: 25px;
    width: 100%;
  }
}
</style>